import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.9533 7.01323L15.3105 9.65604L10.0249 4.37043L12.6677 1.72762L17.9533 7.01323ZM8.69884 5.68715L6.05604 8.32996L19.2607 21.5347L21.9035 18.8918L8.69884 5.68715ZM13.3027 20.4047H2.09649V22.2724H13.3027V20.4047ZM10.0249 14.9323L4.7393 9.64668L2.09649 12.2895L7.3821 17.5751L10.0249 14.9323Z",
      fill: "#6D7278"
    }, null, -1)
  ])))
}
export default { render: render }